import React, {useEffect, useContext} from 'react';
import Create from './submit/create';
import Login from './submit/login';
import {CdnPath} from '../../shared/cdn-image'
import QuoteContext from "../quote-context";


const Submit = ({ locationImage, processForm, siteId }) => {

	const {navigation, navigationDispatcher, formDispatcher, formData } = useContext(QuoteContext);

	useEffect(()=>{
		window.scrollTo({
			top: 137,
			behavior: 'smooth',
		})
	},[])

	const removeActivity = (eventId) => {
		formDispatcher({type: "REMOVE_ACTIVITY", event:{id: eventId}});
	}

	const hasAccom = formData.hotel ? true : false;
	const items = ( hasAccom ? 1 : 0 ) + formData.activities.length;
	let accomName = null;
	let nights = 0;
	if( hasAccom ) {
		accomName = formData.hotel.type == "default" ? `${formData.hotel.name} Accommodation` : formData.hotel.name;
		nights = formData.hotel.nights;
	}

	return (
		<div className="full-width-block pd-v-md">
			<div className="row reverse">
				<div className="column two-thirds">
					<div className="pd-r-dsk-xlrg mg-b-tch-lrg">

						<h2 className="mg-b-lrg">Get your quote</h2>

						<div className="align-content vertical center tabs mg-b-tch mg-b-dsk-lrg">
							<div onClick={() => {
								formDispatcher({type: "UPDATE_FIELD", key: "createAccount", value: true })
								navigationDispatcher({
									type: 'TRACK_EVENT',
									action: 'event',
									category: 'click',
									name: 'create-account',
									trigger: 'web-js',
									data: null
								});

							}} className={formData.createAccount ? `tab active` : `tab`}>New user</div>
							<div onClick={() => {
								formDispatcher({type: "UPDATE_FIELD", key: "createAccount", value: false })
								navigationDispatcher({
									type: 'TRACK_EVENT',
									action: 'event',
									category: 'click',
									name: 'login',
									trigger: 'web-js',
									data: null
								});
							}} className={!formData.createAccount ? `tab active` : `tab`}>Login</div>
						</div>

						<div className="tab-panels border-dsk">
							{ !formData.createAccount ? (
								<div className="pd-dsk-md">
									<Login processForm={processForm} />
								</div>
							) : (
								<div className="pd-dsk-md">
									<Create processForm={processForm} siteId={siteId} />
								</div>
							)}
						</div>
					</div>
				</div>

				<div className="column one-third">
					<div className="content-block shadow-mob radius mg-b-tch-lrg">
						<div className="pd-tch-md pd-h-dsk-md">
							<Summary
								navigation={navigation}
								navigationDispatcher={navigationDispatcher}
								locationImage={locationImage}
								hasAccom={hasAccom}
								accomName={accomName}
								removeActivity={removeActivity}
								formData={formData}
								nights={nights}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const Summary = ({ navigation, navigationDispatcher, locationImage, hasAccom, accomName, removeActivity, formData, nights }) => {

	return (
		<>
			<div className="full-width-block">
				<div className="row no-padding">
					<div className="column">
						<div className="full-width-block">
							<div className="row no-padding">
								<div className="column">
									<h3>Your {navigation.destination.name} {navigation.tag} experience</h3>
								</div>
							</div>
						</div>
						<div className="height-250 radius mg-b" style={{backgroundSize: `cover`, backgroundImage: `url(${CdnPath(navigation.siteId, locationImage, 'locations', 400 )})`}}>
							<div className="image-overlay bottom"></div>
							<div className="align-content wrap full-height horizontal left vertical bottom">
								<div className="grid-item small-half">
									<div className="align-content vertical horizontal-tab center mg-l mg-b">
										<span className="icon icon-location white left"></span>
										<p className="white">{navigation.destination.name}</p>
									</div>
								</div>
								<div className="grid-item small-half">
									<div className="align-content vertical horizontal-tab center mg-b">
										<span className="icon icon-group white left"></span>
										<p className="white">{formData.pax} guests</p>
									</div>
								</div>
								<div className="grid-item small-half">
									<div className="align-content vertical horizontal-tab center mg-l mg-b">
										<span className="icon icon-cal white left"></span>
										<p className="white">{formData.date}</p>
									</div>
								</div>
								{ formData.nights != 0 ?
									<div className="grid-item small-half">
										<div className="align-content vertical horizontal-tab center mg-b">
											<span className="icon icon-singlebed white left"></span>
											<p className="white">{formData.nights} nights</p>
										</div>
									</div>
								: null }
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="full-width-block">
				<div className="row no-padding">
					<div className="column">
						<h4 className="mg-b-sm">{formData.package ? formData.package.name : 'Activities'}</h4>
					</div>
				</div>
			</div>
			<div className="full-width-block mg-b">
				<div className="row no-padding">
					<div className="column">
						{ formData.activities.map( act =>
							<div className="align-content vertical center split mg-b" key={ `basket-act-` + act.id } >
								<p>{ act.name }</p>
								{ !formData.package && <span className="icon icon-close small" onClick={() => removeActivity(act.id)}></span> }
							</div>
						)}
						<button
							onClick={() => navigationDispatcher({ type: "GOTO_STEP", step: "itinerary", params: null})}
							className="button primary radius fit-content"
						>
							<span className="icon icon-plus white small left"></span> Add more activities
						</button>
					</div>
				</div>
			</div>

			<div className="divider mg-b"></div>

			<div className="full-width-block">
				<div className="row no-padding">
					<div className="column">
						<h4 className="mg-b-sm">Accommodation</h4>
					</div>
				</div>
			</div>
			
			<div className="full-width-block mg-b">
				<div className="row no-padding">
					<div className="column">
						{hasAccom ? (
							<div className="align-content vertical center">
								<span className="mg-r">{accomName}, </span>
								<span>{nights} nights</span>
							</div>
						) : (
							<>
							<p className="text-left mg-b">None selected</p> 
							<button
								onClick={() => navigationDispatcher({ type: "GOTO_STEP", step: "itinerary", params: null})}
								className="button primary radius fit-content"
							>
								<span className="icon icon-plus white small left"></span> Add accommodation
							</button>
							</>
						)}
						
						
					</div>
				</div>
			</div>
			<div className="divider mg-b show-for-large"></div>
		</>
	)
}

export default Submit;
